import React from "react";
import InvoiceInterface from "../interface/invoiceInterface";
import DiscountController from "../Controller/DiscountController";
import {useTranslation} from "react-i18next";

export default function DiscountForm({state, setState}: {
    state: InvoiceInterface,
    setState: React.Dispatch<React.SetStateAction<InvoiceInterface>>
}) {
    const {t} = useTranslation();

    if (!state.discount.show)
        return null

    return (
        <form className={`discount-form ${state.notAvailableProduct?.length ? 'mt-0' : ""}`}
              onSubmit={(e) => new DiscountController(state, setState).discountCalculation()}>
            <div>
                <div>
                    <input type="text" placeholder={t("invoice.enterDiscountCode")}
                           onChange={e => new DiscountController(state, setState).setDiscountCode(e.target.value)}/>
                </div>
                <button
                    onClick={(e) => new DiscountController(state, setState).discountCalculation(e)}>
                    {t("apply")}
                </button>
            </div>
            {state.error.status ? <p className={'error'}>{state.error.message}</p> : null}
        </form>
    );
}